const auth = {
  email: 'Email',
  password: 'Password',
  welcomeMessage: 'Sign in to your account',

  validations: {
    email: {
      required: 'Email is required',
      email: 'Invalid email address',
      emailReceived: 'The email address you received from your admin',
    },
    password: {
      required: 'Password is required',
      password: 'Invalid Password',
    },
    otp: {
      required: '6 digits code is required.',
      invalid: 'The code you inserted is invalid.'
    }
  },
  resetPassword: {
    email: 'Email is missing',
    resetToken: 'Reset token is invalid',
  },
  loginBtn: 'Login',
  toast: {
    authFailed: 'Email or password is invalid',
    unexpectedError: 'Unexpected error occurred',
    codeInvalid: 'Verification failed. Please make sure you entered the correct 6-digit code or request a new one.',
    securityUpdate: 'Security policies have been updated. We apologize for any inconvenience.',
  },

  toastBlockRequest: {
    body: 'You\'ve been temporarily blocked due to too many failed attempts. Please try again later',
  },

  /** 2FA related translations below */
  twoFactorAuthSelectMessage: 'Choose Verification Method',
  twoFactorAuthVerifyMessage: 'Verify This Device',
  twoFactorAuthVerifyLabel: 'Please enter the 6-digit code we just sent to you.',
  sendVerificationCodeBtn: 'Send Verification Code',
  phoneMethodLabel: 'SMS',
  verifyBtn: 'Submit',
  resendVerificationCodeBtn: 'Resend Code',
  resendVerificationCodeLbl: 'Resend code in {{seconds}}s..',
};

export default auth;
